import { z } from 'zod';

export const RoleTypeSchema = z.enum([
  'ADMIN',
  'OPERATOR',
  'SUPERVISOR',
  'SALES',
]);
export type RoleType = z.infer<typeof RoleTypeSchema>;

export const RoleSchema = z.object({
  id: z.string(),
  createdDate: z.string(),
  description: z.string(),
  name: z.string(),
  type: RoleTypeSchema,
  updatedDate: z.string().optional(),
});

export type Role = z.infer<typeof RoleSchema>;

export function hasRole(roles: Role[], type: RoleType) {
  return roles.some((role) => role.type === type);
}
